import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { SystemModuleSelectComponent } from './system-module-select.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';

@NgModule({
  declarations: [SystemModuleSelectComponent
    ,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    DialogSaveCloseModule,
    DialogContainerModule
  ],
  exports: [
    SystemModuleSelectComponent
  ]
})
export class SystemModuleSelectModule { }
